import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate';
//import VeeValidate from 'vee-validate';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

Vue.config.productionTip = false;
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.use(VeeValidate, {
    fieldsBagName: '$_fields',
    //    errorBagName: '$_errors',
//    locale: 'uk',
    locale: 'ru',
    dictionary: {
        ru: {
            messages: {
                required: 'Поле не может быть пустым',
                confirmed: 'Пароли не совпадают'
            }
        }
        
//        uk: {
//            messages: {
//                numeric: 'Введіть будь-ласка число',
//                required: 'Поле повинно мати значення',
//                size: 'Файл більше 50мб',
//                alpha: 'Дозволено вводити тільки символи кирилиці',
//                alpha_spaces: 'Введіть будь-лакса літери',
//                min_value: 'Значення нижче допустимого',
//                min: 'Мінімальна кількість',
//                max_value: 'Значення вище допустимого',
//                decimal: 'Значення повинно бути числом',
//                length: 'Номер не заповнений',
//                regex: 'Поле  має невірний формат',
//            },
//        },
    },
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
